import { SpinLoaderDirective } from '@myre/ui-primitive-components';
import { TranslatePipe } from '@myre/ui-primitive-core';
import { FormComponent, QuestionHidden } from '@myre/ui-primitive-forms';

import { AsyncPipe } from '@angular/common';
import { Component, inject, type OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { of, type Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import {
  type IModalComponent,
  type IModalContext,
} from '../../../modal.interface';
import { ModalService } from '../../../modal.service';

@Component({
  selector: 'myre-modal-body-default',
  templateUrl: './app-modal-body-default.component.html',
  styleUrls: ['./app-modal-body-default.component.scss'],
  imports: [
    SpinLoaderDirective,
    FormsModule,
    FormComponent,
    ReactiveFormsModule,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class DefaultBodyComponent implements IModalComponent, OnInit {
  private _modalService = inject(ModalService);

  public isLoading$: Observable<boolean> = of(false);
  public hasVisibleElement$: Observable<boolean> = of(false);
  public uid: string;
  public context: IModalContext;
  public data: any;

  public ngOnInit(): void {
    const modalData = this._modalService.getModal(this.uid);

    if (modalData) {
      this.context = modalData.context;
      this.data = modalData.body ? modalData.body.data : {};

      this.hasVisibleElement$ = this.context.elements.pipe(
        filter(els => !!els),
        map(els =>
          els.some(
            e =>
              !(e instanceof QuestionHidden) &&
              (e.enabled || e.keepOnDisabled) &&
              e.visible,
          ),
        ),
      );
    }
  }
}
